export default class Clinic {
    static getClinicId() {
        if (location.search) {
            const data = window.queryString.parse(location.search);

            if (data.clinic_id !== undefined && typeof data.clinic_id === 'string') {
                return parseInt(data.clinic_id);
            }
        }

        return null;
    }
}
